module.exports = __webpack_public_path__ + "static/pid-ug-7-en-successfullyactivated-f41f01541f93cfd13a94d03d45a0a0cb.png";